import { createSignal } from "solid-js";

export type StreakCelebration = {
  kind: "streak";
  from: number;
  to: number;
};

export type SessionCelebration = {
  kind: "session";
  minutes: number;
  title: string;
};

export type RitualCelebration = StreakCelebration | SessionCelebration;

const [celebration, setCelebration] = createSignal<RitualCelebration | null>(
  null,
);

/** Reactive celebration payload for the global overlay. */
export function streakCelebrationSignal() {
  return celebration;
}

export function showStreakCelebration(from: number, to: number): boolean {
  if (!Number.isFinite(from) || !Number.isFinite(to)) return false;
  if (to <= from) return false;
  setCelebration({ kind: "streak", from, to });
  return true;
}

export function showSessionCelebration(minutes: number, title: string): boolean {
  const mins = Number.isFinite(minutes) ? Math.max(0, Math.round(minutes)) : 0;
  setCelebration({ kind: "session", minutes: mins, title: title.trim() });
  return true;
}

export function dismissStreakCelebration() {
  setCelebration(null);
}

/**
 * Call after profile refresh following a completed workout.
 * Shows the cinematic streak overlay only when the weekly streak grew.
 */
export function maybeCelebrateStreakIncrease(
  previous: number | null | undefined,
  next: number | null | undefined,
): boolean {
  const from = previous ?? 0;
  const to = next ?? 0;
  return showStreakCelebration(from, to);
}
